import React from "react";
import { useTranslation } from "react-i18next";
import { PropTypes } from "prop-types";
import { Box, Typography } from "@mui/material";

const labelWidth = 160;
const AnswersField = ({ renderAnswers }) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" mt={2.25} flexDirection={{ xs: "column", md: "row" }}>
      <Typography variant="h5" sx={{ minWidth: labelWidth, mt: 0.75, mb: 3 }}>
        {t("editQuestion.answersLabel")}
      </Typography>
      <Box
        maxWidth={{ xs: "unset", md: `calc(100% - ${labelWidth}px)` }}
        flex={1}
      >
        {renderAnswers()}
      </Box>
    </Box>
  );
};

AnswersField.propTypes = {
  renderAnswers: PropTypes.func
};

export default AnswersField;
